import Footer from 'cms/components/Footer'
import Mainmenu from 'cms/components/Mainmenu'
import Navbar from 'cms/components/Navbar'
import React from 'react'
import VideoGalleriesList from './components/video_galleries_list'

function VideoGalleries() {
  return (
    <div className="wrapper">
      <Navbar />
      <Mainmenu />
      <VideoGalleriesList />
      <Footer />

    </div>
  )
}

export default VideoGalleries